/* global WebFont */

// import "@babel/polyfill";
// import "classlist-polyfill";
import "events-polyfill";
import "webfontloader";

import("a11y-dialog").then(({ default: A11yDialog }) => {
  window.A11yDialog = A11yDialog;
});

// import WebVTTParser from "webvtt-parser";
import domready from "domready";
import { connectableObservableDescriptor } from "rxjs/internal/observable/ConnectableObservable";

window.domready = domready;

export default function main() {
  window.loadWebFonts = () => {
    let families = []; //["Amatic SC", "Montserrat:300,400,600"];
    if (document.body.classList.contains("t-fic-type--fell")) {
      families = ["IM Fell Great Primer", "IM Fell Great Primer SC"];
    }
    if (document.body.classList.contains("t-fic-type--girl")) {
      families = ["The Girl Next Door", "Quicksand"];
    }
    if (document.body.classList.contains("t-fic-type--julius")) {
      families = ["Julius Sans One", "Montserrat"];
    }
    if (document.body.classList.contains("t-fic-type--yeseva")) {
      families = ["Scope One", "Yeseva One"];
    }
    if (document.body.classList.contains("t-fic-type--nixie")) {
      families = ["Nixie One", "Libre Baskerville"];
    }
    if (document.body.classList.contains("t-fic-type--cinzel")) {
      families = ["Cinzel Decorative", "Amiri"];
    }
    if (document.body.classList.contains("t-fic-type--muli")) {
      families = ["Muli", "Muli"];
    }
    if (document.body.classList.contains("t-fic-type--saira")) {
      families = ["Saira", "Saira"];
    }
    if (document.body.classList.contains("t-fic-type--maven")) {
      families = ["Maven Pro", "Maven Pro"];
    }
    if (document.body.classList.contains("t-fic-type--vollkorn")) {
      families = ["Vollkorn", "Vollkorn"];
    }
    if (document.body.classList.contains("t-fic-type--alegreya")) {
      families = ["Alegreya", "Alegreya"];
    }
    if (document.body.classList.contains("t-fic-type--josefin")) {
      families = ["Josefin Slab", "Josefin Sans"];
    }
    if (document.body.classList.contains("t-fic-type--abril1")) {
      families = ["Abril Fatface", "Josefin Sans"];
    }
    if (document.body.classList.contains("t-fic-type--flamenco")) {
      families = ["Flamenco", "Asap"];
    }
    if (document.body.classList.contains("t-fic-type--lobster")) {
      families = ["Lobster", "Cabin"];
    }
    if (document.body.classList.contains("t-fic-type--pacifico")) {
      families = ["Pacifico", "Arimo"];
    }
    if (document.body.classList.contains("t-fic-type--dancing")) {
      families = ["Dancing Script", "Ledger"];
    }
    if (document.body.classList.contains("t-fic-type--biospace")) {
      families = ["BioRhyme", "Space Mono"];
    }
    if (document.body.classList.contains("t-fic-type--space")) {
      families = ["Space Mono", "Space Mono"];
    }
    if (document.body.classList.contains("t-fic-type--ultra")) {
      families = ["Ultra", "Slabo 13px"];
    }
    if (document.body.classList.contains("t-fic-type--annie")) {
      families = ["Annie Use Your Telescope", "Quicksand"];
    }
    if (document.body.classList.contains("t-fic-type--ptsans")) {
      families = ["pt sans narrow", "pt serif"];
    }

    if (document.body.classList.contains("t-fic-type--ptsans-pcol")) {
      families = ["pt sans narrow", "pt serif"];
    }

    if (document.body.classList.contains("t-fic-type--ptsans-allcol")) {
      families = ["pt sans narrow", "pt serif"];
    }
    if (families.length) {
      WebFont.load({ google: { families } });
    }
  };
  domready(() => {
    window.loadWebFonts();
    const menuItems = document.querySelectorAll("li.has-submenu");
    const captionInputs = document.querySelectorAll('textarea[name="captions"]');
    let open;

    const copyClipButtons = document.querySelectorAll("[data-copy-clipboard-target]");

    Array.from(copyClipButtons).forEach((el) => {
      el.addEventListener("click", () => {
        const target = document.querySelector(`#${el.getAttribute("data-copy-clipboard-target")}`);
        if (target) {
          target.select();
          document.execCommand("copy");
          const message = el.getAttribute("data-copied-message");
          if (message) {
            el.textContent = message;
          }
        }
      });
    });

    function pmThemeToggle(prefix, value) {
      Array.from(document.body.classList).forEach((c) => {
        if (c.indexOf(prefix) === 0) {
          document.body.classList.remove(c);
        }
      });
      document.body.classList.add(`${prefix}${value}`);
      document.body.classList.add("t-fic");
      window.loadWebFonts();
    }

    const toggleTypography = document.querySelector('[data-toggle="typography"]');
    const toggleTheme = document.querySelector('[data-toggle="theme"]');
    const toggleTexture = document.querySelector('[data-toggle="texture"]');

    if (toggleTypography && toggleTypography.value) {
      toggleTypography.addEventListener("change", () =>
        pmThemeToggle("t-fic-type--", toggleTypography.value),
      );
      toggleTypography.dispatchEvent(new Event("change"));
    }
    if (toggleTheme && toggleTheme.value) {
      toggleTheme.addEventListener("change", () =>
        pmThemeToggle("t-fic-theme--", toggleTheme.value),
      );
      toggleTheme.dispatchEvent(new Event("change"));
    }
    if (toggleTexture && toggleTexture.value) {
      toggleTexture.addEventListener("change", () =>
        pmThemeToggle("t-fic-texture--", toggleTexture.value),
      );
      toggleTexture.dispatchEvent(new Event("change"));
    }

    const closeMenu = (parent) => {
      open = null;
      parent.classList.remove("open");
      parent.querySelector('[aria-expanded="true"]').setAttribute("aria-expanded", "false");
    };

    const openMenu = (target) => {
      target.parentNode.classList.add("open");
      target.setAttribute("aria-expanded", "true");
      open = target.parentNode;
    };

    Array.from(menuItems).forEach((el) => {
      el.querySelector("a").addEventListener("click", (event) => {
        // console.log("here");
        // Nav is open, new nav clicked
        const newmenu = event.target.parentNode !== open;
        if (open) {
          closeMenu(open);
        }

        if (newmenu) {
          openMenu(event.target);
        }
        event.preventDefault();
        return false;
      });
    });

    Array.from(document.querySelectorAll("[data-subscribe-event]")).forEach((el) => {
      el.addEventListener("change", (e) => {
        var xhr = new XMLHttpRequest();
        xhr.open(
          "POST",
          `/appointment/update/${el.getAttribute("data-subscribe-event")}/${el.checked ? 1 : 0}/`,
          true,
        );

        //Send the proper header information along with the request
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        xhr.setRequestHeader(
          "X-CSRFToken",
          document.querySelector("[data-csrf]").getAttribute("data-csrf"),
        );

        xhr.onreadystatechange = function () {
          // Call a function when the state changes.
          if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
            // Request finished. Do processing here.
            console.log(this);
          }
        };
        xhr.send("");
      });
    });

    if (captionInputs) {
      import("webvtt-parser")
        .then(({ default: webvtt }) => {
          const vttParser = new webvtt.WebVTTParser();
          Array.from(captionInputs).forEach((el) => {
            const help = el.parentElement.nextElementSibling.classList.contains("c-form__help-text")
              ? el.parentElement.nextElementSibling
              : null;
            const validation = document.createElement("div");
            if (help) {
              help.appendChild(validation);
            }
            const validateVtt = (e) => {
              // const vttParser = new WebVTTParser(window, WebVTT.StringDecoder());
              if (el.value && el.value.trim() !== "") {
                el.value = el.value.replace(/(\d{2}):(\d{2}):(\d{2}),(\d{3})/g, "$1:$2:$3.$4");
                try {
                  const tree = vttParser.parse(el.value, "metadata");
                  // console.log(tree, tree.errors);
                  if (tree.errors.length) {
                    const message = `<strong>Parser could not validate that this was VTT, had the following message:</strong> ${tree.errors
                      .map((e) => e.message)
                      .join("<br>")}`;
                    // el.setCustomValidity(message);
                    validation.innerHTML = message;
                  } else {
                    if (help && validation) {
                      validation.innerHTML = "";
                    }
                  }
                } catch (error) {
                  const message = `<strong>Parser could not validate that this was VTT, had the following message: ${error.message}</strong>`;
                  if (help && validation) {
                    validation.innerHTML = message;
                  }
                  // e.target.setCustomValidity(message);
                }
              }
            };
            el.addEventListener("keyup", validateVtt);
            el.addEventListener("change", validateVtt);
            el.addEventListener("paste", validateVtt);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }

    window.addEventListener("click", (e) => {
      if (open && !open.contains(e.target)) {
        closeMenu(open);
      }
    });

    if (document.querySelector("textarea[data-markdown]")) {
      import("./prosemirror").then(({ default: wysiwyg }) => {
        wysiwyg();
      });
    }

    const currencyInputs = Array.from(document.querySelectorAll("input[data-currency]"));
    currencyInputs.forEach((el) =>
      el.addEventListener("blur", () => {
        const value = el.value.replace(/,/g, "");
        el.value = parseFloat(value).toLocaleString("en-US", {
          style: "decimal",
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        });
      }),
    );

    const warningToggles = Array.from(document.querySelectorAll("[data-warningtoggle]"));

    function toggle(el, off) {
      const label = document.querySelector(`#${el.getAttribute("aria-controls")}`);
      if (label) {
        const textarea = label.querySelector("textarea");
        const required = textarea && el.getAttribute("data-codename") === "other";
        label.setAttribute("aria-hidden", !el.checked);
        if (el.checked) {
          if (required) {
            textarea.setAttribute("required", required);
          }
          label.classList.remove("u-sr");
        } else {
          label.classList.add("u-sr");
          if (required) {
            textarea.removeAttribute("required");
          }
        }
      }
    }

    warningToggles.forEach(function (el) {
      const group = el.parentElement.parentElement.parentElement.parentElement.parentElement;
      const solo = el.hasAttribute("data-solo");
      const others = warningToggles.filter((oel) => oel !== el);
      console.log(el);

      el.addEventListener("change", () => {
        toggle(el);
        if (solo) {
          others.forEach((oel) => {
            oel.disabled = el.checked;
            if (oel.checked && el.checked) {
              oel.checked = false;
              toggle(oel);
            }
          });
        }
      });
      toggle(el);
    });
  });
}
